import React from "react";
import { useLang } from "@/context/LanguageContext";
import { ShieldCheck, Award, MapPin } from "lucide-react";

export default function TrustBar() {
  const { t } = useLang();
  const items = [
    { icon: ShieldCheck, title: t.trust.insured, desc: t.trust.insured_desc, testid: "trust-insured" },
    { icon: Award, title: t.trust.certified, desc: t.trust.certified_desc, testid: "trust-certified" },
    { icon: MapPin, title: t.trust.dual, desc: t.trust.dual_desc, testid: "trust-dual" },
  ];

  return (
    <section data-testid="trust-bar" className="relative -mt-0 md:-mt-0 z-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="bg-white border border-jungle grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-jungle/10">
          {items.map(({ icon: Icon, title, desc, testid }, i) => (
            <div key={i} data-testid={testid} className="p-6 md:p-8 flex items-start gap-4">
              <div className="shrink-0 w-12 h-12 border border-jungle/20 flex items-center justify-center rounded-sm text-terracotta">
                <Icon size={22} />
              </div>
              <div>
                <div className="font-display text-xl text-jungle">{title}</div>
                <div className="text-forest text-sm mt-1 leading-relaxed">{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
